module.exports = __webpack_public_path__ + "img/frame6.bbddafb0.png";